module.exports = __webpack_public_path__ + "static/media/26.cdde23ee.mp3";